import { observer } from 'mobx-react-lite';
import { useMainContext } from '../../hooks/useMainContext';
import { useEffect } from 'react';

export const DrawingBase = observer(() => {
    const { drawingManager } = useMainContext();

    return (
        <>
            <canvas
                className="annotation-canvas"
                style={{ position: 'absolute' }}
                ref={(ref) => ref && drawingManager.setAnnotationCanvas(ref)}
            />
        </>
    );
});
